import React from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
  Box,
} from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import InventoryIcon from "@mui/icons-material/Inventory";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import PeopleIcon from "@mui/icons-material/People";
import Person4Icon from '@mui/icons-material/Person4';
// import PersonIcon from "@mui/icons-material/Person";
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import CategoryIcon from "@mui/icons-material/Category";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { usePermission } from "../../hooks/usePermission";

const drawerWidth = 240;

const Sidebar = ({ mobileOpen, handleDrawerToggle, isMobile }) => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const { hasPermission } = usePermission();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const menuItems = [
    {
      text: "Bảng điều khiển",
      icon: <DashboardIcon />,
      path: "/dashboard",
      permission: null,
    },
    {
      text: "Sản phẩm",
      icon: <InventoryIcon />,
      path: "/products",
      permission: "product:read",
    },
    {
      text: "Danh mục",
      icon: <CategoryIcon />,
      path: "/categories",
      permission: "category:read",
    },
    {
      text: "Đơn hàng",
      icon: <ShoppingCartIcon />,
      path: "/orders",
      permission: "order:read",
    },
    {
      text: "Khách hàng",
      icon: <PeopleIcon />,
      path: "/customers",
      permission: "customer:read",
    },
    {
      text: "Tài khoản",
      icon: <Person4Icon />,
      path: "/profile",
      permission: null,
    },    {
      text: "Bật thông báo",
      icon: <NotificationsActiveIcon />,
      path: "/subcriber",
      permission: null,
    },
    {
      text: "Quản lý Super Admin",
      icon: <AdminPanelSettingsIcon />,
      path: "/super-admin/users",
      permission: "user:super_manage",
    },
    // {
    //   text: "Quản lý người dùng",
    //   icon: <PersonIcon />,
    //   path: "/users",
    //   permission: "user:manage",
    // },
  ];

  const drawer = (
    <div>
      {!isMobile && (
        <Toolbar>
          <Typography variant="h6" noWrap component="div">
            Logo
          </Typography>
        </Toolbar>
      )}
      <List sx={{  mt: isMobile ? "64px" : 0, }}>
        {menuItems.map(
          (item) =>
            (item.permission === null || hasPermission([item.permission])) && (
              <ListItem
                key={item.text}
                disablePadding
                onClick={() => {
                  navigate(item.path);
                  if (isMobile) handleDrawerToggle(); // Close drawer on mobile after navigation
                }}
              >
                <ListItemButton>
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText primary={item.text} />
                </ListItemButton>
              </ListItem>
            )
        )}
        <ListItem disablePadding onClick={handleLogout}>
          <ListItemButton>
            <ListItemIcon>
              <LogoutIcon />
            </ListItemIcon>
            <ListItemText primary="Đăng xuất" />
          </ListItemButton>
        </ListItem>
      </List>
    </div>
  );

  return (
    <Box
      component="nav"
      sx={{ width: { md: drawerWidth }, flexShrink: { md: 0 } }}
      aria-label="mailbox folders"
    >
      {/* The implementation can be swapped with js to avoid SEO duplication of the NavDrawer. */}
      <Drawer
        variant={isMobile ? "temporary" : "permanent"}
        open={isMobile ? mobileOpen : true}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          display: { xs: "block", md: "block" },
          // Adjust for AppBar height on mobile
          "& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth },
        }}
      >
        {drawer}
      </Drawer>
    </Box>
  );
};

export default Sidebar;
